import api from "./api";
import endpoints from "./endpoints";

export default {
  loadProfile: async function () {
    const result = await api.get(endpoints.user.profile.get);
    return result.data;
  },
  changePassword: async function (currentPassword: string | null, newPassword: string, userId: string | null = null) {
    const result = await api.post(endpoints.user.profile.changePassword, { currentPassword, newPassword }, { params: { userId } });
    return result.data;
  },
  getUserProfileImage: async function (userId: string): Promise<string> {
    const result = await api.get(endpoints.user.profile.getProfileImage, { params: { userId } });
    return result.data;
  }
};
